module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (spectatorMode) { ;
__p += '\n    <div class="spectator-mode-scene-cover"></div>\n';
 } ;
__p += '\n<div class="scenes-region inline">\n    <div class="content-shadow"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/ExperienceEditor.tpl
// module id = 3016
// module chunks = 0